var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"m-nav-grid__item",attrs:{"href":_vm.value,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_c('i',{staticClass:"m-nav-grid__icon flaticon-time"})])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-502ab3d2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/metronic/table/value/links/Page.vue
// module id = 3BL0
// module chunks = 0 1 2